import { useAppSelector } from '../../state/hooks';
import { store } from '../../state/store';
import { StepperDispatchers, StepperSelectors } from './stepper.interfaces';
import { selectActiveStep } from './stepper.slice';

export class StepperService {
  selectActiveStep = selectActiveStep;
  constructor(
    private dispatchers: StepperDispatchers,
    private stepperSelectors: StepperSelectors,
  ) {}

  dispatchResetStepper(): void {
    store.dispatch(this.dispatchers.resetStepper());
  }

  dispatchIncrementActiveStep(): void {
    store.dispatch(this.dispatchers.incrementActiveStep());
  }

  dispatchDecrementActiveStep(): void {
    store.dispatch(this.dispatchers.decrementActiveStep());
  }

  dispatchIncrementActiveStepBy(num: number): void {
    store.dispatch(this.dispatchers.incrementActiveStepBy(num));
  }

  dispatchDecrementActiveStepBy(num: number): void {
    store.dispatch(this.dispatchers.decrementActiveStepBy(num));
  }

  dispatchNextEnabled(enabled: boolean): void {
    store.dispatch(this.dispatchers.setNextEnabled(enabled));
  }

  dispatchBackEnabled(enabled: boolean): void {
    store.dispatch(this.dispatchers.setBackEnabled(enabled));
  }

  useActiveStepSelector = () => {
    return useAppSelector(this.stepperSelectors.selectActiveStep);
  };
  useNextEnabledSelector = () => {
    return useAppSelector(this.stepperSelectors.selectNextEnabled);
  };
  useBackEnabledSelector = () => {
    return useAppSelector(this.stepperSelectors.selectBackEnabled);
  };

  activeStepSelector = () => {
    return this.stepperSelectors.selectActiveStep;
  };
}
